<template>
	<div>

		<div v-if="init" style="max-height:75vh;" class="border border-gray-300 mb-12 mt-12 overflow-x-scroll w-11/12">
			<table class="table relative w-full">
				<thead>
					<tr>
						<th rowspan="2" class="sticky" style="top: -1px;">
							<div class="flex items-center">
								<div>Name</div>
								<div class="ml-2 text-gray-600 cursor-pointer" @click="sort.name = !sort.name">
									<Zondicon v-if="sort.name" icon="arrow-thick-down" class="w-4 fill-current" />
									<Zondicon v-else icon="arrow-thick-up" class="w-4 fill-current" />
								</div>
							</div>
						</th>
						<th rowspan="2" class="sticky" style="top: -1px;">Number</th>
						<th rowspan="2" class="sticky" style="top: -1px;">Role</th>
						<th colspan="2" class="sticky z-20 text-center w-40" style="top: -1px;">Dashboard (M)</th>
						<th colspan="2" class="sticky z-20 text-center w-40" style="top: -1px;">Dashboard (A)</th>
						<th colspan="2" class="sticky z-20 text-center w-40" style="top: -1px;">Vacations</th>
						<th colspan="2" class="sticky z-20 text-center w-40" style="top: -1px;">Users</th>
						<th colspan="2" class="sticky z-20 text-center w-40" style="top: -1px;">Permissions</th>
					</tr>
					<tr>
						<th class="text-xs text-center py-2 h-auto sticky z-20" style="top: 47px;">View</th>
						<th class="text-xs text-center py-2 h-auto sticky z-20" style="top: 47px;">Edit</th>
						<th class="text-xs text-center py-2 h-auto sticky z-20" style="top: 47px;">View</th>
						<th class="text-xs text-center py-2 h-auto sticky z-20" style="top: 47px;">Edit</th>
						<th class="text-xs text-center py-2 h-auto sticky z-20" style="top: 47px;">View</th>
						<th class="text-xs text-center py-2 h-auto sticky z-20" style="top: 47px;">Edit</th>
						<th class="text-xs text-center py-2 h-auto sticky z-20" style="top: 47px;">View</th>
						<th class="text-xs text-center py-2 h-auto sticky z-20" style="top: 47px;">Edit</th>
						<th class="text-xs text-center py-2 h-auto sticky z-20" style="top: 47px;">View</th>
						<th class="text-xs text-center py-2 h-auto sticky z-20" style="top: 47px;">Edit</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="user in filteredUsers" :key="user.uid" :class="getRoleClass(user.role)">
						<td>
							<div class="flex items-center">
								<span>
									<Zondicon icon="user" class="w-4 mr-4 fill-current" />
								</span>
								<span>{{ user.name }}</span>
							</div>
						</td>
						<td>{{ user.number }}</td>
						<td>{{ getRoleName(user.role) }}</td>
						<td class="text-center">
							<span class="tooltip">
								<input
									type="checkbox"
									:disabled="!canAccess('canEditPermissions')"
									@click.prevent="showModal(user.uid, 'canViewManagerDashboard')"
									v-model="user.canViewManagerDashboard">
								<span class="tooltip-text -mt-6 -ml-24">Dashboard (Manager): can view</span>
							</span>
						</td>
						<td class="text-center">
							<span class="tooltip">
								<input
									type="checkbox"
									:disabled="!user.canViewManagerDashboard || !canAccess('canEditPermissions')"
									@click.prevent="showModal(user.uid, 'canEditManagerDashboard')"
									v-model="user.canEditManagerDashboard">
								<span class="tooltip-text -mt-6 -ml-24">Dashboard (Manager): can edit</span>
							</span>
						</td>


						<td class="text-center">
							<span class="tooltip">
								<input
									type="checkbox"
									:disabled="!canAccess('canEditPermissions')"
									@click.prevent="showModal(user.uid, 'canViewAccounterDashboard')"
									v-model="user.canViewAccounterDashboard">
								<span class="tooltip-text -mt-6 -ml-24">Dashboard (Accounter): can view</span>
							</span>
						</td>
						<td class="text-center">
							<span class="tooltip">
								<input
									type="checkbox"
									:disabled="!user.canViewAccounterDashboard || !canAccess('canEditPermissions')"
									@click.prevent="showModal(user.uid, 'canEditAccounterDashboard')"
									v-model="user.canEditAccounterDashboard">
								<span class="tooltip-text -mt-6 -ml-24">Dashboard (Accounter): can edit</span>
							</span>
						</td>

						<td class="text-center">
							<span class="tooltip">
								<input
									type="checkbox"
									:disabled="!canAccess('canEditPermissions')"
									@click.prevent="showModal(user.uid, 'canViewVacations')"
									v-model="user.canViewVacations">
								<span class="tooltip-text -mt-6 -ml-16">Vacations: can view</span>
							</span>
						</td>
						<td class="text-center">
							<span class="tooltip">
								<input
									type="checkbox"
									:disabled="!user.canViewVacations || !canAccess('canEditPermissions')"
									@click.prevent="showModal(user.uid, 'canEditVacations')"
									v-model="user.canEditVacations">
								<span class="tooltip-text -mt-6 -ml-16">Vacations: can edit</span>
							</span>
						</td>


						<td class="text-center">
							<span class="tooltip">
								<input
									type="checkbox"
									:disabled="!canAccess('canEditPermissions')"
									@click.prevent="showModal(user.uid, 'canViewUsers')"
									v-model="user.canViewUsers">
								<span class="tooltip-text -mt-6 -ml-16">Users section: can view</span>
							</span>
						</td>
						<td class="text-center">
							<span class="tooltip">
								<input
									type="checkbox"
									:disabled="!user.canViewUsers || !canAccess('canEditPermissions')"
									@click.prevent="showModal(user.uid, 'canEditUsers')"
									v-model="user.canEditUsers">
								<span class="tooltip-text -mt-6 -ml-16">Users section: can edit</span>
							</span>
						</td>


						<td class="text-center">
							<span class="tooltip">
								<input
									type="checkbox"
									:disabled="!canAccess('canEditPermissions')"
									@click.prevent="showModal(user.uid, 'canViewPermissions')"
									v-model="user.canViewPermissions">
								<span class="tooltip-text -mt-6 -ml-16">Permissions: can view</span>
							</span>
						</td>
						<td class="text-center">
							<span class="tooltip">
								<input
									type="checkbox"
									:disabled="!user.canViewPermissions || !canAccess('canEditPermissions')"
									@click.prevent="showModal(user.uid, 'canEditPermissions')"
									v-model="user.canEditPermissions">
								<span class="tooltip-text -mt-6 -ml-24">Permissions: can edit</span>
							</span>
						</td>
					</tr>
				</tbody>
			</table>
		</div>

		<div v-else class="loader loader-dark loader-big ml-4 mt-4 mr-0 mb-0"></div>

		<SimpleModal v-if="modal" @action="editAccessControl" @close="modal = false" :btnClass="'btn-secondary'">
            <template v-slot:title>Edit User Access Control</template>
            <template v-slot:body>Are you sure you want to edit user access control for <strong>{{ getUserName() }}</strong>?</template>
            <template v-slot:button>Yes</template>
        </SimpleModal>
		

	</div>
</template>

<script>
import { mapState } from "vuex";
import { db, auth } from "@/firebase";
import Zondicon from 'vue-zondicons'
import axios from 'axios'
import helper from '../helpers'

import SimpleModal from '@/components/SimpleModal.vue'

export default {
	data() {
		return {
			modal: false,
			uid: '',
			accessType: null,
			sort: {
				name: true
			}
		};
	},

	computed: {

		...mapState({
			currentUser: state => state.user.info,
			roles: state => state.roles,
			users: state => state.users,
		}),

		init() {
			if (this.users && this.roles) return true
			return false
		},

		filteredUsers() {
			var users = this.users

			users = users.filter(user => {
				if (user.role !== 'superadmin' && !user.archived) return 1
			})

			users = users.sort((a, b) => {
				if (this.sort.name) {
					return a.name.localeCompare(b.name)
				}
				if (!this.sort.name) {
					return b.name.localeCompare(a.name)
				}
			})

			return users;
		}
	},

	components: {
		SimpleModal,
		Zondicon
	},

	methods: {

		canAccess(type) {
            return helper.canAccess(type, this.currentUser)
		},

		showModal(uid, type) {
			this.accessType = type
			this.uid = uid
			this.modal = true
		},

		getUserName() {
			return this.users.find(user => user.uid == this.uid).name
		},

		getRoleName(id) {
			if (this.roles) {
				return this.roles.find(role => role.id == id).name
			}
			return id
		},

		getRoleClass(roleId) {
            var className = ''
            switch (roleId) {
                case 'nZorCHA3D3opPKdu4Arx':
                    className = 'manager'
                    break;
                case 'rPHdxrt3Uatga4u9jx5T':
                    className = 'team-leader'
                    break;
                case 'u3WQdP6NiAhPrdQsBM4N':
                    className = 'accounter'
                    break;
            }
            
            return className;

		},

		editAccessControl() {
			
			var user = this.filteredUsers.find(user => user.uid == this.uid)

			if (user && this.accessType) {
				db
				.collection("users")
				.doc(this.uid)
				.update({
					[this.accessType]: !user[this.accessType]
				})
				.then(() => {
					this.modal = false
					this.$toasted.show("Saved successfully!", {
						type: 'success'
					})
				})
				.catch(error => {
					this.modal = false
					this.$toasted.show(`Error: ${error}`, {
						type: 'error'
					})
				});

			}
			
		}

	},

	created() {
		if (!this.users) this.$store.dispatch('getUsers')
		if (!this.roles) this.$store.dispatch('getRoles')
		this.$store.commit('SET_TITLE', 'User Access Control')
	}


};
</script>